<template>
    <div class="">
        <transition-group name="shrink">
            <FileUploader
                v-for="(uploader, i) in uploaders"
                :key="uploader"
                :required="i == 0 && required"
                :name="uploader"
                :class="{ 'mt-3': i > 0 }"
                class="max-h-20"
            />
        </transition-group>
        <span
            v-if="uploaders.length < fileLimit"
            role="button"
            tabindex="0"
            class="mt-3 text-base btn btn--sm btn--no-min"
            @click.prevent="addUploader"
            @keydown.space.prevent="addUploader"
            @keydown.enter.prevent="addUploader"
        >
            Add another file
        </span>
        <span
            v-if="uploaders.length > 1"
            role="button"
            tabindex="0"
            class="mt-3 text-base btn btn--sm btn--no-min"
            @click="removeUploader"
            @keydown.space.prevent="removeUploader"
            @keydown.enter.prevent="removeUploader"
        >
            Remove file
        </span>
    </div>
</template>

<script>
import FileUploader from '@/vue/components/FileUploader';

export default {
    components: {
        FileUploader
    },

    props: {
        name: {
            type: String,
            required: true
        },
        required: {
            type: Boolean,
            required: true
        },
        fileLimit: {
            type: Number,
            required: true
        }
    },

    data: () => ({
        uploaderCount: 1
    }),

    computed: {
        uploaders() {
            let names = [];
            for (let i = 0; i < this.uploaderCount; i++) {
                names.push(`${this.name}[${i}]`);
            }
            return names;
        }
    },

    methods: {
        addUploader() {
            this.uploaderCount += 1;
        },
        removeUploader() {
            this.uploaderCount -= 1;
        }
    }
};
</script>
